import { useMutation, gql } from "@apollo/client"
import moment from "moment"
import { makeOptimisticUserFromPrincipal } from "../makeOptimistic"
import { ACTIONS_QUERY, ACTION_FIELDS } from "./useQueryActions"

const UPDATEACTION_MUTATION = gql`
  ${ACTION_FIELDS}
  mutation UpdateAction($id: ID!, $title: String!, $content: String!, $users: [ID!], $groups: [ID!], $uploads: [ID!]) {
    updateAction(id: $id, title: $title, content: $content, users: $users, groups: $groups, uploads: $uploads) {
      ...ActionFields
    }
  }
`

const RESOLVEACTION_MUTATION = gql`
  ${ACTION_FIELDS}
  mutation ResolveAction($id: ID!) {
    resolveAction(id: $id) {
      ...ActionFields
    }
  }
`

const UNRESOLVEACTION_MUTATION = gql`
  ${ACTION_FIELDS}
  mutation UnresolveAction($id: ID!) {
    unresolveAction(id: $id) {
      ...ActionFields
    }
  }
`

const makeUpdateActionOptimisticResponse = ({ mutationName, action, principal }) => ({
  __typename: "Mutation",
  [mutationName]: {
    __typename: "Action",
    ...action,
    resolvedAt: mutationName === "unresolveAction" ? null : action.resolvedAt || moment(),
    resolvedBy:
      mutationName === "unresolveAction" ? null : action.resolvedBy || makeOptimisticUserFromPrincipal(principal),
  },
})

const useMutationUpdateAction = () => useMutation(UPDATEACTION_MUTATION)

const useMutationResolveAction = () =>
  useMutation(RESOLVEACTION_MUTATION, {
    refetchQueries: [{ query: ACTIONS_QUERY, variables: { set: "unresolved" } }],
  })

const useMutationUnresolveAction = () =>
  useMutation(UNRESOLVEACTION_MUTATION, {
    refetchQueries: [{ query: ACTIONS_QUERY, variables: { set: "resolved" } }],
  })

export {
  useMutationUpdateAction,
  useMutationResolveAction,
  useMutationUnresolveAction,
  makeUpdateActionOptimisticResponse,
}
